import { ROLE_VALUE } from "constants/Constants";
import i18n from "i18n";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

export const convertOption = (array) => {
  return array.map((item, index) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
};
export const convertOptionMaster = (array) => {
  return array.map((item, index) => {
    return {
      value: item.code,
      label: item.value,
    };
  });
};
export const convertOptionDiaper = (array) => {
  return array.map((item, index) => {
    return {
      value: item.id,
      label: item.size,
    };
  });
};
export const convertObjectToParams = (obj) => {
  return new URLSearchParams(obj).toString();
};

export const showToastSuccess = (message) => {
  toast.success(i18n.t(message), {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
    autoClose: 3000,
  });
};

export const showToastError = (message) => {
  toast.error(i18n.t(message), {
    position: toast.POSITION.TOP_RIGHT,
  });
};

export const isAuth = () => {
  const access_token = Cookies.get("access_token");

  let isAuth = false;
  if (access_token) {
    isAuth = true;
  }

  return isAuth;
};

export const isSanwaAdmin = () => {
  const userInfo = JSON.parse(Cookies.get("USER_INFO") || "{}");
  return userInfo.role === ROLE_VALUE.ADMIN;
};

export const isSanwaClinic = () => {
  const userInfo = JSON.parse(Cookies.get("USER_INFO") || "{}");
  return userInfo.role === ROLE_VALUE.CLINIC;
};

export const getUserInfo = () => {
  const userInfo = JSON.parse(Cookies.get("USER_INFO") || "{}");
  return userInfo;
};

export const setPatientInfo = (patient) => {
  localStorage.setItem("PATIENT_INFO", JSON.stringify(patient || {}));
};

export const getPatientInfo = () => {
  return JSON.parse(localStorage.getItem("PATIENT_INFO") || "{}");
};
